import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

const normalize = (response: any) => {
    if (response?.data?._result) return response;
    const items = response?.data?.data ?? [];
    const total = response?.data?.total ?? items.length;
    response.data = {_result: {items, total}};
    return response;
};

export const getTpvTransactions = async (filters: any = {}) => {
    const qs = FilterBuilder.hashMapToQueryString(filters);
    const response = await http.get('/payment-orders/payments' + (qs ? '?' + qs : ''));
    return normalize(response);
};
